import React, { useEffect, useState, useRef } from "react";
import "reactjs-popup/dist/index.css";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import swal from "sweetalert";
import { Col, Card, Table, Alert, Spinner, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
function UserCustomer() {
  const history = useHistory();
  //const datas = document.querySelectorAll("#job_data tbody tr");
  const sort = 25;
  const activePag = useRef(0);
  const [spinner, setSpinner] = useState(true);
  const [show, setShow] = useState(false);
  const [multiNot, setMultiNote] = useState(false);
  const [userId, setUserId] = useState("");
  const [summary, setSummary] = useState("");
  const [data, setData] = useState([]);
  const [datas, setDatas] = useState([]);
  const [checkedId, setCheckedId] = useState([]);
  const [unblockallusers, setunblockallusers] = useState(false);
  const [blockallusers, setblockallusers] = useState(false);
  const [allusers, setallusers] = useState(true);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  function isNumeric(value) {
    return /^-?\d+$/.test(value);
  }

  function searchFunction(value) {
  
      axios
      .get(`${Baseurl.baseurl}/user/search-user/0?query=${value}`)
      .then((res) => {
        setData(res.data.users);
        setDatas(document.querySelectorAll("#job_data tbody tr"));
      })
      .catch((err) => {});
 
  }
  function getData(length) {
    axios
      .get(`${Baseurl.baseurl}/user/get-all-users/${length}`)
      .then((res) => {
        if (res.data.status) {
          setSpinner(false);

          setData(
            (oldArray) => oldArray.concat(res.data.users),
            () => {}
          );
          setDatas(document.querySelectorAll("#job_data tbody tr"));
        } else {
          swal("No More Data", "", "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < datas.length; ++i) {
      if (i >= frist && i < sec) {
        datas[i].classList.remove("d-none");
      } else {
        datas[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(datas.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };
  useEffect(() => {
    getData(data.length);
  }, []);
  const blockuser = (userId, blockStatus) => {
    const reasonData = {
      reason: "Rules Voilation",
    };
    if (blockStatus === false) {
      axios
        .put(`${Baseurl.baseurl}/user/block-user/${userId}`, reasonData)
        .then((response) => {
          if (response.data.status) {
            swal("blocked", response.data.message, "success", {
              button: "Done",
              timer: 1000,
            });
            let result = data.filter((val) => {
              if (val._id != userId) {
                return val;
              } else {
                val["Block"] = true;
                return val;
              }
            });
            setData(result);
            setDatas(document.querySelectorAll("#job_data tbody tr"));
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 1000,
            });
          }
        })
        .catch((err) => {
          if (err.toString() === "Error: Network Error") {
            history.push("/offline");
          } else {
            history.push("/400");
          }
        });
    } else {
      axios
        .put(`${Baseurl.baseurl}/user/unblock-user/${userId}`)
        .then((response) => {
          if (response.data.status) {
            swal("Unblocked", response.data.message, "success", {
              button: "Done",
              timer: 1000,
            });
            let unblockData = data.filter((val) => {
              if (val._id !== userId) {
                return val;
              } else {
                val["Block"] = false;
                return val;
              }
            });
            setData(unblockData);
            setDatas(document.querySelectorAll("#job_data tbody tr"));
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 1000,
            });
          }
        })
        .catch((err) => {
          if (err.toString() === "Error: Network Error") {
            history.push("/offline");
          } else {
            history.push("/400");
          }
        });
    }
  };
  const change = (num) => {
    if (num === 1) {
      setunblockallusers(false);
      setblockallusers(false);
      setallusers(true);
    } else if (num === 2) {
      setunblockallusers(false);
      setblockallusers(true);
      setallusers(false);
    } else if (num === 3) {
      setunblockallusers(true);
      setblockallusers(false);
      setallusers(false);
    }
  };
  function sendNotification() {
    const data = new FormData();
    let testJson = {
      title: tittle,
      body: body,
      category: type,
      summaryText: summary,
      packageTestId:packageId
    };
    data.append("data", JSON.stringify(testJson));
    data.append("image", image);
    var config = {
      method: "post",
      url: `${Baseurl.baseurl}/admin/send-single-user-notification/${userId}`,
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.status) {
          setBody("");
          setImage(null);
          setImageData(null);
          setTittle("");
          setSummary("");
          setPackageId("")
          swal("Notification Sent", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          setShow(false);
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function sendMultipleNotification() {
      const data = new FormData();
      let testJson = {
        title: tittle,
        body: body,
        category: type,
        summaryText: summary,
        packageTestId:packageId,
        userId: checkedId,
      };
      data.append("data", JSON.stringify(testJson));
      data.append("image", image);
      var config = {
        method: "post",
        url: `${Baseurl.baseurl}/admin/send-multiple-user-notification`,
        data: data,
      };
  
      axios(config)
        .then(function (response) {
          if (response.data.status) {
            setBody("");
            setImage(null);
            setImageData(null);
            setTittle("");
            setSummary("");
            setPackageId("")
            swal("Notification Sent", response.data.message, "success", {
              button: "Done",
              timer: 1000,
            });
            setShow(false);
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 1000,
            });
          }
        })
        .catch((err) => {
          if (err.toString() === "Error: Network Error") {
            history.push("/offline");
          } else {
            history.push("/400");
          }
        });
  }
  function saveCheckedIds(id) {
    if (checkedId.length !== 0) {
      if (checkedId.includes(id)) {
        let idx = checkedId.indexOf(id);
        if (idx !== -1) {
          checkedId.splice(idx, 1);
        }
      } else {
        setCheckedId([...checkedId, id]);
      }
    } else {
      setCheckedId([...checkedId, id]);
    }
  }
  const [tittle, setTittle] = useState("");
  const [body, setBody] = useState("");
  const [imageData, setImageData] = useState(null);
  const [image, setImage] = useState(null);
  const onChangePicture = (e) => {
    if (e.target.files[0].size / 1048576 < 3) {
      setImage(e.target.files[0]);
      if (e.target.files[0]) {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          setImageData(reader.result);
        });
        reader.readAsDataURL(e.target.files[0]);
      }
    } else {
      swal("Oops", "image size should be less than 3MB", "error", {
        button: "Done",
        timer: 2000,
      });
      setImageData(null);
    }
  };
  const [type, setType] = useState("Normal");
  const [packageId, setPackageId] = useState("");
  const TypesObject = ["Normal", "Image"];
  return (
    <Col lg={12}>
      <Modal
        size="lg"
        show={show}
        onHide={() => {
          setShow(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Send Notification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-sm-6">
              <label>
                Type <span className="text-danger">*</span>
              </label>
              <select
                className="col-sm-12 text-primary p-2 custom-select"
                id="val-skill"
                name="val-skill"
                placeholder="Select Search Item"
                defaultValue={type}
                onChange={(event) => {
                  setType(event.target.value);
                }}
              >
                {TypesObject &&
                  TypesObject.map((val) => <option value={val}>{val}</option>)}
              </select>
            </div>
            <div className="col-sm-6">
              <label>
                Tittle <span className="text-danger">*</span>
              </label>
              <input
                value={tittle}
                type="text"
                className="form-control"
                placeholder="enter tittle"
                onChange={(e) => setTittle(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="row mt-4">
            {type === "Normal" ? (
              <div className="col-sm-6">
                <label>
                  Body <span className="text-danger">*</span>
                </label>
                <input
                  value={body}
                  type="text"
                  className="form-control"
                  placeholder="enter body"
                  onChange={(e) => setBody(e.target.value)}
                  required
                />
              </div>
            ) : (
              <>
                <div className="col-sm-6">
                  <label htmlFor="val-range">
                    Image
                    <span className="text-danger">*</span>
                  </label>
                  <div className="register_profile_image mt-2">
                    <input
                      id="profilePic"
                      type="file"
                      onChange={(e) => {
                        onChangePicture(e);
                      }}
                    />
                  </div>
                  {imageData && (
                    <div
                      style={{
                        marginTop: "5px",
                        width: 180,
                        height: 100,
                        aspectRatio: 1 * 1.4,
                      }}
                      className="previewProfilePic"
                    >
                      <img
                        alt=""
                        className="playerProfilePic_home_tile"
                        style={{
                          resizeMode: "cover",
                          width: "100%",
                          height: "100%",
                        }}
                        src={imageData}
                      />
                    </div>
                  )}
                </div>
                <div className="col-sm-6">
                  <label>
                    <strong>Summary</strong>
                  </label>
                  <textarea
                    value={summary}
                    type="text"
                    className="form-control"
                    placeholder="enter message"
                    onChange={(e) => setSummary(e.target.value)}
                    required
                  />
                </div>
              </>
            )}
            <div className={`col-sm-6 ${type !== "Normal"&&"mt-4"}`}>
              <label>
                Test Or Package Id <span className="text-danger">*</span>
              </label>
              <input
                value={packageId}
                type="text"
                className="form-control"
                placeholder="copy and paste the test or package id"
                onChange={(e) => setPackageId(e.target.value)}
                required
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-primary"
            onClick={() => {
              if (multiNot) {
                sendMultipleNotification();
              } else {
                sendNotification();
              }
            }}
          >
            Send
          </button>
        </Modal.Footer>
      </Modal>
      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <div>
            <input
              type="text"
              id="myInput"
              onChange={(e) => {
                searchFunction(e.target.value);
              }}
              className="form-control col-sm-12"
              placeholder="Search here..."
            />
          </div>
          {multiNot && (
            <button
              className={"btn btn-primary"}
              onClick={() => {
                setShow(true);
              }}
            >
              Send
            </button>
          )}

          {/* <button
            className={
              allusers ? "btn btn-success ml-2" : "btn btn-primary ml-2"
            }
            onClick={() => change(1)}
          >
            All Users
          </button>
          <button
            className={
              blockallusers ? "btn btn-success ml-2" : "btn btn-primary ml-2"
            }
            onClick={() => change(2)}
          >
            Blocked Users
          </button>
          <button
            className={
              unblockallusers ? "btn btn-success ml-2" : "btn btn-primary ml-2"
            }
            onClick={() => change(3)}
          >
            UnBlocked Users
          </button> */}
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center mt-5">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table
                responsive
                id="myTable"
                className="table text-white text-center text-sm"
              >
                <thead>
                  <tr>
                    <th></th>
                    <th>
                      <strong>USER ID.</strong>
                    </th>
                    <th>
                      <strong> NAME</strong>
                    </th>
                    <th>
                      <strong>Email</strong>
                    </th>
                    <th>
                      <strong>Phone</strong>
                    </th>
                    <th>
                      <strong>Status</strong>
                    </th>
                    <th>
                      <strong>Active</strong>
                    </th>
                    {/* <th>
                      <strong>Wallet</strong>
                    </th> */}
                    {/* <th>
                      <strong>Actions</strong>
                    </th> */}
                    <th>
                      <strong>Notification</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {allusers &&
                    data &&
                    data.map((user) => (
                      <tr key={user.id}>
                        <td>
                          {" "}
                          <input
                            onClick={() => {
                              saveCheckedIds(user._id);
                              setMultiNote(true);
                            }}
                            type="checkbox"
                            className="mb-3 mt-3"
                            id="checkAll"
                            required
                          />
                        </td>
                        <td>{user._id}</td>
                        <td>{user.Name}</td>
                        <td>{user.Email ? user.Email : "-----"}</td>
                        <td>{user.Phone}</td>
                        {user.Block ? <td>Blocked</td> : <td>Unblocked</td>}
                        <td>
                          {user.Logged_In ? (
                            <div className="d-flex align-items-center">
                              <i className="fa fa-circle text-success mr-1"></i>{" "}
                              Online
                            </div>
                          ) : (
                            <div className="d-flex align-items-center">
                              <i className="fa fa-circle text-danger mr-1 "></i>
                              Offline
                            </div>
                          )}
                        </td>
                        {/* <td>{user.User_Wallet}</td> */}
                        {/* <td>
                          <button
                            className="btn btn-primary"
                            style={{ fontSize: 11, padding: 8 }}
                            onClick={() => blockuser(user._id, user.Block)}
                          >
                            {user.Block === true ? "UnBlock" : "Block"}
                          </button>
                        </td> */}
                        <td>
                          <button
                            className="btn btn-primary ml-1"
                            style={{ fontSize: 10, padding: 8 }}
                            onClick={() => {
                              setShow(true);
                              setUserId(user._id);
                              setMultiNote(false);
                            }}
                          >
                            Send Notification
                          </button>
                        </td>
                      </tr>
                    ))}

                  {blockallusers &&
                    data &&
                    data.map((user) =>
                      user.Block === true ? (
                        <tr key={user.id}>
                          <td>{user._id}</td>
                          <td>{user.Name}</td>
                          <td>{user.Email ? user.Email : "-----"}</td>
                          <td>{user.Phone}</td>
                          {user.Block ? <td>Blocked</td> : <td>Unblocked</td>}
                          <td>
                            {user.Logged_In ? (
                              <div className="d-flex align-items-center">
                                <i className="fa fa-circle text-success mr-1"></i>{" "}
                                Online
                              </div>
                            ) : (
                              <div className="d-flex align-items-center">
                                <i className="fa fa-circle text-danger mr-1 "></i>
                                Offline
                              </div>
                            )}
                          </td>
                          <td>{user.User_Wallet}</td>
                          <td>
                            <button
                              className="btn btn-primary"
                              onClick={() => blockuser(user._id, user.Block)}
                            >
                              {user.Block === true ? "UnBlock" : "Block"}
                            </button>
                          </td>
                        </tr>
                      ) : (
                        ""
                      )
                    )}
                  {unblockallusers &&
                    data &&
                    data.map((user) =>
                      user.Block === false ? (
                        <tr key={user.id}>
                          <td>{user._id}</td>
                          <td>{user.Name}</td>
                          <td>{user.Email ? user.Email : "-----"}</td>
                          <td>{user.Phone}</td>
                          {user.Block ? <td>Blocked</td> : <td>Unblocked</td>}
                          <td>
                            {user.Logged_In ? (
                              <div className="d-flex align-items-center">
                                <i className="fa fa-circle text-success mr-1"></i>{" "}
                                Online
                              </div>
                            ) : (
                              <div className="d-flex align-items-center">
                                <i className="fa fa-circle text-danger mr-1 "></i>
                                Offline
                              </div>
                            )}
                          </td>
                          <td>{user.User_Wallet}</td>
                          <td>
                            <button
                              className="btn btn-primary"
                              onClick={() => blockuser(user._id, user.Block)}
                            >
                              {user.Block === true ? "UnBlock" : "Block"}
                            </button>
                          </td>
                        </tr>
                      ) : (
                        ""
                      )
                    )}
                </tbody>
              </Table>
            )}

            {!data && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero riders
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {datas.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : datas.length}{" "}
                of {datas.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
                <button
                  onClick={() => {
                    getData(data.length);
                  }}
                  className="btn btn-primary ml-2"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default UserCustomer;
